"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStakingController = exports.prepareStorage = exports.getAuthorization = exports.prepareSetStakingController = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
const internal_2 = require("../../utils/internal");
/**
 * @hidden
 */
function prepareSetStakingController(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx: { staking: { setController }, }, }, }, context, storage: { actingAccount, currentController, newControllerLedger: targetLedger }, } = this;
        const { controller: controllerInput } = args;
        const controller = (0, internal_2.asAccount)(controllerInput, context);
        if (targetLedger) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.UnmetPrerequisite,
                message: 'The given controller is already paired with a stash',
                data: {
                    givenController: controller.address,
                    givenControllerStash: targetLedger.stash.address,
                },
            });
        }
        if (!currentController) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.DataUnavailable,
                message: 'Current controller not found. The acting account must be a stash account',
                data: { actingAccount: actingAccount.address },
            });
        }
        const rawController = (0, conversion_1.stringToAccountId)(controller.address, context);
        return {
            transaction: setController,
            args: [rawController],
            resolver: undefined,
        };
    });
}
exports.prepareSetStakingController = prepareSetStakingController;
/**
 * @hidden
 * @note the staking module is exempt from permission checks
 */
function getAuthorization() {
    return {
        permissions: {
            assets: [],
            transactions: [],
            portfolios: [],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
function prepareStorage(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context } = this;
        const targetController = (0, internal_2.asAccount)(args.controller, context);
        const actingAccount = yield context.getActingAccount();
        const [currentController, newControllerLedger] = yield Promise.all([
            actingAccount.staking.getController(),
            targetController.staking.getLedger(),
        ]);
        return {
            actingAccount,
            currentController,
            newControllerLedger,
        };
    });
}
exports.prepareStorage = prepareStorage;
/**
 * @hidden
 */
const setStakingController = () => new internal_1.Procedure(prepareSetStakingController, getAuthorization, prepareStorage);
exports.setStakingController = setStakingController;
//# sourceMappingURL=setStakingController.js.map